import React from "react";

import icons from "./icons";

interface IconProps {
  icon: string;
  color?: string;
}

const Icon: React.FC<IconProps> = ({ icon = "", color }) => {
  if (!icon || !icons[icon]) {
    console.error(`Icon "${icon}" doesn't exist!`);
    return null;
  }

  const iconDef = icons[icon].icon;

  // Проверяем, является ли иконка функцией
  if (typeof iconDef === "function") {
    return iconDef({ color });
  }

  // Иначе возвращаем ReactElement напрямую
  return iconDef;
};

export default Icon;
